import { render, staticRenderFns } from "./TaskModule.vue?vue&type=template&id=d5764c2c&scoped=true"
import script from "./TaskModule.vue?vue&type=script&lang=js"
export * from "./TaskModule.vue?vue&type=script&lang=js"
import style0 from "./TaskModule.vue?vue&type=style&index=0&id=d5764c2c&prod&lang=scss&scoped=true"
import style1 from "./TaskModule.vue?vue&type=style&index=1&id=d5764c2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5764c2c",
  null
  
)

export default component.exports